// extracted by mini-css-extract-plugin
export default {"list":"Dz9lZ","item":"fANZh","link":"IOn8j","icon":"uR0nN","iconWithBackground":"TIDeU","matchesCount":"LRwkO","itemSelected":"FJJcx","label":"ONhII","caption":"a1y_d"};